import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { getCurrentDateTime, getDateDifference, getKeyPathValue, request, toast } from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { BANK_CASH, PAYMENT_MODE, PAYMENT_TYPE, RECEIPT_MODE } from '../../../../../constants';
import { IPDSearchHandler } from './utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';

const TABLE_HEADER = [
  {
    header: 'Doc No. ',
    accessor: 'receipt_no'
  },
  {
    header: 'Doc Date',
    accessor: (row) => `${getCurrentDateTime('date', row.date)}`
  },
  {
    header: 'UHID NO',
    accessor: (row) => row?.patient?.uhid
  },
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name ',
    accessor: (row) => `${row?.patient?.first_name} ${row?.patient?.last_name}`
  },
  {
    header: ' Amount',
    accessor: 'received_amount'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const RECIEPT_TABLE_HEADER = [
  ...TABLE_HEADER,
  {
    header: 'Created By',
    accessor: (row) => row?.createdBy
  }
];

const initialReceiptVoucherDataObj = {
  data: [],
  loading: false
};

const initialTodayReceiptDataObj = {
  data: [],
  totalAmount: 0,
  loading: true
};

export const ReceiptVoucher = () => {
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [receiptVoucherDataObj, setReceiptVoucherDataObj] = useState(initialReceiptVoucherDataObj);
  const [todayReceiptDataObj, setTodayReceiptDataObj] = useState(initialTodayReceiptDataObj);
  const [IPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [input, setInput] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [balance, setBalance] = useState(0);
  const [originalData, setOriginalData] = useState([]);
  const [selectedData, setSelectedData] = useState([]);
  const [totalNetAmount, setTotalNetAmount] = useState(0);
  const [totalReceivedAmount, setTotalRecievedAmount] = useState(0);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);
  const [indoorTotalReceipt, setIndoorTotalReceipt] = useState(0);
  const [totalDisc, setTotalDisc] = useState(0);
  const [finalBillTotalDisc, setFinalBillTotalDisc] = useState(0);
  const [totalRoomCharge, setTotalRoomCharge] = useState(0);
  const user = JSON.parse(localStorage.getItem('user'));
  console.log('HELLLO USERS', user);
  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  console.log('HELLO isEnable', isEnabledDate);

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' '),
        ipd_no: Yup.string().required(' '),
        patient_name: Yup.string().required(' '),
        recieved_amount: Yup.string().required(' '),
        payment_mode: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      recieved_amount: 0
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const { first_name, last_name, ...others } = selectedRecord;
      setValue(
        'patient_name',
        `${selectedRecord?.patient?.name_suffix}${selectedRecord?.patient?.first_name} ${selectedRecord?.patient?.last_name}`
      );
      const keyValuePair = getKeyPathValue(others, '', ['_id', 'status', 'createdAt']);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      const formattedRegDate = selectedRecord?.date ? new Date(selectedRecord.date).toISOString().split('T')[0] : '';
      setValue('date', formattedRegDate);
      setValue('time', selectedRecord?.time);
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getTodayReceiptVoucher = async () => {
    setLoading(true);
    const response = await request('/receipt-voucher-list', { method: 'GET', query: { date: new Date() } });
    if (response.success) {
      setTodayReceiptDataObj({
        loading: false,
        data: response?.data?.data || [],
        totalAmount: response?.data?.totalAmount
      });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setTodayReceiptDataObj({ loading: false });
    }
  };

  useEffect(() => {
    getTodayReceiptVoucher();
  }, []);

  const formSubmitHandler = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/receipt-voucher-update' : '/receipt-voucher-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'Updated' : 'Created'} Receipt Voucher`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      getTodayReceiptVoucher();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Receipt Voucher`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/receipt-voucher-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted Receipt Voucher', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete Receipt Voucher', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setReceiptVoucherDataObj({ loading: true });
    const response = await request('/receipt-voucher-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data?.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setReceiptVoucherDataObj({ loading: false, data: sortedData });
      setOriginalData(sortedData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setReceiptVoucherDataObj({ loading: false });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (receiptVoucherDataObj.data && receiptVoucherDataObj.data.length > 0) {
      setOriginalData(receiptVoucherDataObj.data);
      setIsFiltered(false);
    }
  }, [receiptVoucherDataObj.data]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    const filtered = receiptVoucherDataObj.data.filter(
      (item) =>
        item.uhid.toString().toLowerCase().includes(lowercasedInput) ||
        item.first_name.toLowerCase().includes(lowercasedInput) ||
        item.ipd_no.toString().toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleUhidSearch();
  };

  const searchIPDDetails = async (ipd_no) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipd_no
    });
    if (response?.success) {
      if (!response?.data) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        const { data: patientData } = response;
        setValue('ipd_no', ipd_no);
        setValue('uhid', patientData.uhid);
        setValue('patient_name', `${patientData.patient.first_name} ${patientData.patient.last_name}`);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const fetchBalanceDetails = async (ipd_no) => {
    setLoading(true);
    const response = await request('/ipd-billing-balance', {
      method: 'GET',
      params: ipd_no
    });
    if (response?.success) {
      if (!response?.data) {
        toast('No IPD found', { variant: 'warning' });
      } else {
        setSelectedData(response?.data[0]);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  useEffect(() => {
    if (!selectedData) return;
    const { indoor_services = [], receipt_voucher = [], refund_voucher = [], roomChargeTracker = [] } = selectedData;

    const totalNetAmount = indoor_services.reduce((acc, voucher) => acc + voucher.net_amt, 0);
    setTotalNetAmount(totalNetAmount);
    console.log(totalNetAmount, 'TOTAL Net AMOUNT');

    const totalReceipt = receipt_voucher.reduce((acc, voucher) => acc + voucher.received_amount, 0);
    setTotalRecievedAmount(totalReceipt);
    console.log(totalReceipt, 'TOTAL RECEIVED AMOUNT');

    const totalRefund = refund_voucher.reduce((acc, voucher) => acc + voucher.amount, 0);
    setTotalRefundAmount(totalRefund);
    console.log(totalRefund, 'TOTAL REFUND AMOUNT');

    const indoorServiceTotalReceipt = indoor_services.reduce((acc, receipt) => acc + receipt.total_recpt, 0);
    setIndoorTotalReceipt(indoorServiceTotalReceipt);
    console.log(indoorServiceTotalReceipt, 'TOTAL RECEIPT AMOUNT');

    const indoorServiceTotalDisc = indoor_services.reduce((acc, receipt) => acc + receipt.disc_amt, 0);
    setTotalDisc(indoorServiceTotalDisc);
    console.log(indoorServiceTotalDisc, 'TOTAL DISCOUNT');

    const finalBillDiscAmount = indoor_services.reduce((acc, receipt) => acc + receipt.add_discount, 0);
    setFinalBillTotalDisc(finalBillDiscAmount);
    console.log(finalBillDiscAmount, 'FINAL BILL TOTAL DISC');

    const RoomChargeAmount = roomChargeTracker.reduce((acc, receipt) => acc + receipt.net_amt, 0);
    setTotalRoomCharge(RoomChargeAmount);
    console.log(RoomChargeAmount, 'Room Charge');
  }, [selectedData]);

  useEffect(() => {
    setBalance((prevBalance) => {
      const newBalance =
        totalNetAmount +
        totalRefundAmount +
        totalRoomCharge -
        (totalReceivedAmount + indoorTotalReceipt + finalBillTotalDisc + totalDisc);
      return newBalance;
    });
  }, [
    totalNetAmount,
    totalReceivedAmount,
    totalRefundAmount,
    indoorTotalReceipt,
    finalBillTotalDisc,
    totalDisc,
    totalRoomCharge
  ]);
  console.log(balance, 'HELLLO BALANCE');

  if (watch('payment_type') === 'Angst Bill') {
    setValue('received_amount', balance);
  }

  const paymentMode = watch('payment_mode');
  const cashWatch = watch('cash');
  const bankWatch = watch('bank');

  useEffect(() => {
    const sumPayment = (Number(cashWatch) || 0) + (Number(bankWatch) || 0);
    setValue('received_amount', sumPayment);
  }, [cashWatch, bankWatch]);

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmitHandler)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Receipt Voucher
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  onClick={handleDeleteRecord}
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={2}>
                <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Date/Time</Typography>
                    <TextField
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.25 }}
                      type="date"
                      name="date"
                    />
                    <TextField
                      disabled={!isEnabledDate || !['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.55 }}
                      type="time"
                      name="time"
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Receipt No.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Receipt No." name="receipt_no" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Pay Mode</Typography>
                    <SelectTag
                      disabled={!['new', 'edit'].includes(currentAction)}
                      formControlSX={{ flex: 0.8 }}
                      placeholder="Select Payement Mode"
                      name="payment_mode"
                      menus={RECEIPT_MODE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Ledger</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      placeholder="Select Option"
                      name="cash_bank"
                      menus={BANK_CASH}
                      disabled={!['new', 'edit'].includes(currentAction)}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Pay Type</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      disabled={!['new', 'edit'].includes(currentAction)}
                      name="payment_type"
                      placeholder="Select Payment Type"
                      menus={PAYMENT_TYPE}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>UHID No.</Typography>
                    <TextField sx={{ flex: 0.8 }} name="uhid" disabled placeholder="Uhid" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>IPD No.</Typography>
                    <TextField sx={{ flex: 0.7 }} name="ipd_no" disabled placeholder="Search by Ipd" />
                    <Button
                      disabled={!['new'].includes(currentAction)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                      onClick={() => setIPDSearchDialogOpen(true)}
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Patient Name" name="patient_name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Rec.Amt.</Typography>
                    <TextField
                      disabled={true}
                      sx={{ flex: 0.8 }}
                      placeholder="Recieved Amount"
                      name="received_amount"
                      type="number"
                      inputProps={{ min: '0' }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Cash/Bank</Typography>
                    <TextField
                      disabled={
                        !['new', 'edit'].includes(currentAction) ||
                        paymentMode === 'Bank' ||
                        paymentMode === 'both' ||
                        !paymentMode
                      }
                      sx={{ flex: 0.4 }}
                      placeholder="CASH"
                      name="cash"
                      type="number"
                      inputProps={{ min: '0' }}
                    />
                    <TextField
                      disabled={
                        !['new', 'edit'].includes(currentAction) ||
                        paymentMode === 'CASH' ||
                        paymentMode === 'both' ||
                        !paymentMode
                      }
                      sx={{ flex: 0.4 }}
                      placeholder="BANK"
                      name="bank"
                      type="number"
                      inputProps={{ min: '0' }}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.25, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                    <TextField
                      disabled={!['new', 'edit'].includes(currentAction)}
                      sx={{ flex: 0.8 }}
                      placeholder="Remarks"
                      name="remarks"
                    />
                  </Stack>
                </Grid>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Stack spacing={1} direction="row" alignItems="center" justifyContent="space-between">
                    <Stack spacing={1} direction="row" alignItems="center">
                      <Typography variant="h5">Today's Receipt Voucher</Typography>
                    </Stack>
                    <Typography variant="h5">₹{todayReceiptDataObj.totalAmount || 0}</Typography>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1 }}
                    data={todayReceiptDataObj.data || []}
                    columns={RECIEPT_TABLE_HEADER}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Receipt Voucher Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={originalData || []}
          loading={receiptVoucherDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandler
          onClose={() => setIPDSearchDialogOpen(false)}
          onAdd={searchIPDDetails}
          ongetBalance={fetchBalanceDetails}
        />
      </Dialog>
    </>
  );
};
